import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-center mt-8 mb-12 text-xs text-gray-300 font-poppins space-y-2">
      <div className="space-x-4">
        <a
          href="https://www.threads.net/@yaongpainter"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary"
        >
          @Threads
        </a>
        <span>|</span>
        <a href="/privacy-policy" className="hover:text-primary">
          Privacy Policy
        </a>
        <span>|</span>
        <a href="/terms-of-service" className="hover:text-primary">
          Terms of Service
        </a>
      </div>
      <div>© {currentYear} My Radio. All rights reserved.</div>
    </footer>
  );
};

export default Footer;
